import type { ReactNode } from 'react';
import { Card, CardContent } from '@/components/ui/card';

interface SummaryCardProps {
  label: string;
  value: string | number;
  subLabel?: string;
  icon?: ReactNode;
  variant?: 'default' | 'success' | 'warning' | 'danger';
}

const variantClasses = {
  default: 'text-foreground',
  success: 'text-green-600',
  warning: 'text-amber-600',
  danger: 'text-red-600',
};

export function SummaryCard({ label, value, subLabel, icon, variant = 'default' }: SummaryCardProps) {
  return (
    <Card>
      <CardContent className="pt-5 pb-5">
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0">
            <p className="text-sm font-medium text-muted-foreground">{label}</p>
            <p className={`text-2xl font-semibold tracking-tight mt-1 truncate ${variantClasses[variant]}`}>
              {value}
            </p>
            {subLabel && (
              <p className="text-xs text-muted-foreground mt-0.5">{subLabel}</p>
            )}
          </div>
          {icon && (
            <div className="text-muted-foreground shrink-0">{icon}</div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}

interface SummaryCardsGridProps {
  children: ReactNode;
}

export function SummaryCardsGrid({ children }: SummaryCardsGridProps) {
  return (
    <div className="grid gap-4 grid-cols-2 sm:grid-cols-3 lg:grid-cols-3">
      {children}
    </div>
  );
}
